import DefaultLayout from "@/layouts/DefaultLayout/DefaultLayout.vue"
import PERMISSIONS from "@/utils/permissions/index.js"
import createAuthRouteMeta from "@/utils/createAuthRouteMeta"
import * as assetApi from "@/api/asset/api"
import useRouterProtect from "@/composables/useRouterProtect/index.js"

export default [
    {
        path: "/marketing-resources",
        component: DefaultLayout,
        redirect: () => {
            return { name: "edm-list" }
        },
        name: "marketing-resources",
        meta: {
            isShow: true,
            name: "素材管理",
            index: "5",
            position: "left",
            menuGroup: "marketing-resources",
            permissions: [
                PERMISSIONS.VIEW_ASSET,
                PERMISSIONS.VIEW_ARCHIVED_ASSET,
            ],
        },
        children: [
            {
                name: "marketing-resources-assets-edm",
                path: "",
                redirect: () => {
                    return { name: "edm-list" }
                },
                meta: {
                    isShow: true,
                    requiresAuth: true,
                    permissions: [
                        PERMISSIONS.VIEW_ASSET,
                        PERMISSIONS.VIEW_ARCHIVED_ASSET,
                    ],
                    isSubShow: true,
                    subIndex: "1",
                    subGroup: "assets",
                    hasSubMenuGroup: true,
                    subMenuGroup: "郵件素材管理",
                    subMenuGroupIndex: "1",
                },
                children: [
                    // edm 素材管理
                    {
                        path: "edm", // 素材管理列表 edm
                        component: () =>
                            import(
                                "@/pages/MarketingResourcesGroup/MarketingResourcesEDMPage.vue"
                            ),
                        name: "edm-list",
                        meta: {
                            requiresAuth: true,
                            permissions: [PERMISSIONS.VIEW_ASSET],
                            isSubShow: true,
                            subIndex: "1-1",
                            subGroup: "edm",
                            subGroupName: "郵件素材列表",
                            hasSubMenuGroup: false,
                            subMenuGroupIndex: "1",
                            alternativeGroup: "marketing-resources",
                        },
                        props: { isArchived: false },
                    },
                    // EDM 封存區
                    {
                        path: "edm/archived",
                        component: () =>
                            import(
                                "@/pages/MarketingResourcesGroup/MarketingResourcesEDMPage.vue"
                            ),
                        name: "edm-archived",
                        meta: {
                            requiresAuth: true,
                            permissions: [PERMISSIONS.VIEW_ARCHIVED_ASSET],
                            isSubShow: true,
                            subIndex: "1-2",
                            subGroup: "edm",
                            subGroupName: "郵件素材封存區",
                            hasSubMenuGroup: false,
                            alternativeGroup: "marketing-resources",
                        },
                        props: { isArchived: true },
                    },
                    {
                        path: "edm/preference", // 素材管理偏好設定 edm
                        component: () =>
                            import(
                                "@/pages/MarketingResourcesGroup/MarketingResourcesEDMPreferencePage.vue"
                            ),
                        name: "edm-preference",
                        meta: {
                            requiresAuth: true,
                            permissions: [PERMISSIONS.EDIT_ASSET],
                            isSubShow: false,
                            subGroup: "edm",
                        },
                    },
                    {
                        path: "edm/add", // 新增素材 edm
                        component: () =>
                            import(
                                "@/pages/MarketingResourcesGroup/MarketingResourcesEDMAddPage.vue"
                            ),
                        name: "add-edm",
                        meta: createAuthRouteMeta({
                            permissions: [PERMISSIONS.ADD_ASSET],
                            isSubShow: false,
                            subGroup: "edm",
                        }),
                    },
                    {
                        path: "edm/:id", // 查看詳細素材 edm
                        component: () =>
                            import(
                                "@/pages/MarketingResourcesGroup/MarketingResourcesEDMDetailPage.vue"
                            ),
                        name: "edm-detail",
                        meta: createAuthRouteMeta({
                            permissions: [PERMISSIONS.VIEW_ASSET_DETAIL],
                            isSubShow: false,
                            subGroup: "edm",
                        }),
                        props: true,
                        beforeEnter: async (to) => {
                            const [path, response] = await useRouterProtect({
                                to,
                                PERMISSIONS: PERMISSIONS.VIEW_ASSET_DETAIL,
                                api: assetApi.getEdm,
                            })

                            if (path === true) {
                                to.params.initialEdmResponse = response
                            }
                            return path
                        },
                    },
                    {
                        path: "edm/:id/edit", // 編輯素材 edm
                        component: () =>
                            import(
                                "@/pages/MarketingResourcesGroup/MarketingResourcesEDMEditPage.vue"
                            ),
                        name: "edit-edm",
                        meta: createAuthRouteMeta({
                            permissions: [PERMISSIONS.EDIT_ASSET],
                            isSubShow: false,
                            subGroup: "edm",
                        }),
                        props: true,
                        beforeEnter: async (to) => {
                            const [path, response] = await useRouterProtect({
                                to,
                                PERMISSIONS: PERMISSIONS.EDIT_ASSET,
                                api: assetApi.getEdm,
                            })

                            if (path === true) {
                                to.params.initialEdmResponse = response
                            }
                            return path
                        },
                    },

                    {
                        path: "edm/:id/review", // 素材審核 edm
                        component: () =>
                            import(
                                "@/pages/MarketingResourcesGroup/MarketingResourcesEDMReviewPage.vue"
                            ),
                        name: "review-edm",
                        meta: createAuthRouteMeta({
                            permissions: [PERMISSIONS.REVIEW_ASSET],
                            isSubShow: false,
                            subGroup: "edm",
                        }),
                        props: true,
                        beforeEnter: async (to) => {
                            const [path, response] = await useRouterProtect({
                                to,
                                PERMISSIONS: PERMISSIONS.REVIEW_ASSET,
                                api: assetApi.getEdm,
                            })

                            if (path === true) {
                                to.params.initialEdmResponse = response
                            }
                            return path
                        },
                    },
                ],
            },
            {
                name: "marketing-resources-assets-sms",
                path: "",
                redirect: () => {
                    return { name: "sms-list" }
                },
                meta: {
                    isShow: true,
                    requiresAuth: true,
                    permissions: [
                        PERMISSIONS.VIEW_ASSET,
                        PERMISSIONS.VIEW_ARCHIVED_ASSET,
                    ],
                    isSubShow: true,
                    subIndex: "2",
                    subGroup: "assets",
                    hasSubMenuGroup: true,
                    subMenuGroup: "簡訊素材管理",
                    subMenuGroupIndex: "2",
                },
                children: [
                    {
                        path: "sms", // 素材管理列表 sms
                        component: () =>
                            import(
                                "@/pages/MarketingResourcesGroup/MarketingResourcesSMSPage.vue"
                            ),
                        name: "sms-list",
                        meta: {
                            requiresAuth: true,
                            permissions: [PERMISSIONS.VIEW_ASSET],
                            isSubShow: true,
                            subIndex: "2-1",
                            subGroup: "sms",
                            subGroupName: "簡訊素材列表",
                            hasSubMenuGroup: false,
                            subMenuGroupIndex: "2",
                            alternativeGroup: "marketing-resources",
                        },
                        props: { isArchived: false },
                    },
                    {
                        path: "sms/archived",
                        component: () =>
                            import(
                                "@/pages/MarketingResourcesGroup/MarketingResourcesSMSPage.vue"
                            ),
                        name: "sms-archived",
                        meta: {
                            requiresAuth: true,
                            permissions: [PERMISSIONS.VIEW_ARCHIVED_ASSET],
                            isSubShow: true,
                            subIndex: "2-2",
                            subGroup: "sms",
                            subGroupName: "簡訊素材封存區",
                            hasSubMenuGroup: false,
                            subMenuGroupIndex: "2",
                            alternativeGroup: "marketing-resources",
                        },
                        props: { isArchived: true },
                    },
                    {
                        path: "sms/:id", // 素材管理 sms 細節
                        component: () =>
                            import(
                                "@/pages/MarketingResourcesGroup/MarketingResourcesSMSDetailPage.vue"
                            ),
                        name: "sms-detail",
                        meta: createAuthRouteMeta({
                            permissions: [PERMISSIONS.VIEW_ASSET_DETAIL],
                            isSubShow: false,
                            subGroup: "sms",
                        }),
                        props: true,
                        beforeEnter: async (to) => {
                            const [path, response] = await useRouterProtect({
                                to,
                                PERMISSIONS: PERMISSIONS.VIEW_ASSET_DETAIL,
                                api: assetApi.getSms,
                            })

                            if (path === true) {
                                to.params.initialSmsResponse = response
                            }
                            return path
                        },
                    },
                    {
                        path: "sms/add", // 新增素材 sms
                        component: () =>
                            import(
                                "@/pages/MarketingResourcesGroup/MarketingResourcesSMSAddPage.vue"
                            ),
                        name: "add-sms",
                        meta: createAuthRouteMeta({
                            permissions: [PERMISSIONS.ADD_ASSET],
                            isSubShow: false,
                            subGroup: "sms",
                        }),
                    },
                    {
                        path: "sms/:id/edit", // 編輯素材 sms
                        component: () =>
                            import(
                                "@/pages/MarketingResourcesGroup/MarketingResourcesSMSEditPage.vue"
                            ),
                        name: "edit-sms",
                        meta: createAuthRouteMeta({
                            permissions: [PERMISSIONS.EDIT_ASSET],
                            isSubShow: false,
                            subGroup: "sms",
                        }),
                        props: true,
                        beforeEnter: async (to) => {
                            const [path, response] = await useRouterProtect({
                                to,
                                PERMISSIONS: PERMISSIONS.EDIT_ASSET,
                                api: assetApi.getSms,
                            })

                            if (path === true) {
                                to.params.initialSmsResponse = response
                            }
                            return path
                        },
                    },
                    {
                        path: "sms/:id/review", // 審核素材 sms
                        component: () =>
                            import(
                                "@/pages/MarketingResourcesGroup/MarketingResourcesSMSReviewPage.vue"
                            ),
                        name: "review-sms",
                        meta: createAuthRouteMeta({
                            permissions: [PERMISSIONS.REVIEW_ASSET],
                            isSubShow: false,
                            subGroup: "sms",
                        }),
                        props: true,
                        beforeEnter: async (to) => {
                            const [path, response] = await useRouterProtect({
                                to,
                                PERMISSIONS: PERMISSIONS.REVIEW_ASSET,
                                api: assetApi.getSms,
                            })

                            if (path === true) {
                                to.params.initialSmsResponse = response
                            }
                            return path
                        },
                    },
                ],
            },
            {
                name: "marketing-resources-assets-app-push",
                path: "",
                redirect: () => {
                    return { name: "app-push-list" }
                },
                meta: {
                    isShow: true,
                    requiresAuth: true,
                    permissions: [
                        PERMISSIONS.VIEW_ASSET,
                        PERMISSIONS.VIEW_ARCHIVED_ASSET,
                    ],
                    isSubShow: true,
                    subIndex: "3",
                    subGroup: "assets",
                    hasSubMenuGroup: true,
                    subMenuGroup: "AppPush 素材管理",
                    subMenuGroupIndex: "3",
                },
                children: [
                    {
                        path: "app-push", // 素材管理列表 APP推播
                        component: () =>
                            import(
                                "@/pages/MarketingResourcesGroup/MarketingResourcesAppPushPage.vue"
                            ),
                        name: "app-push-list",
                        meta: {
                            requiresAuth: true,
                            permissions: [PERMISSIONS.VIEW_ASSET],
                            isSubShow: true,
                            subIndex: "3-1",
                            subGroup: "app-push",
                            subGroupName: "AppPush 素材列表",
                            hasSubMenuGroup: false,
                            subMenuGroupIndex: "3",
                            alternativeGroup: "marketing-resources",
                        },
                        props: { isArchived: false },
                    },
                    {
                        path: "app-push/archived", // 素材封存區 APP推播
                        component: () =>
                            import(
                                "@/pages/MarketingResourcesGroup/MarketingResourcesAppPushPage.vue"
                            ),
                        name: "app-push-archived",
                        meta: {
                            requiresAuth: true,
                            permissions: [PERMISSIONS.VIEW_ARCHIVED_ASSET],
                            isSubShow: true,
                            subIndex: "3-2",
                            subGroup: "app-push",
                            subGroupName: "AppPush 素材封存區",
                            hasSubMenuGroup: false,
                            subMenuGroupIndex: "3",
                            alternativeGroup: "marketing-resources",
                        },
                        props: { isArchived: true },
                    },
                    {
                        path: "app-push/:id", // 素材細節 APP推播
                        component: () =>
                            import(
                                "@/pages/MarketingResourcesGroup/MarketingResourcesAppPushDetailPage.vue"
                            ),
                        name: "app-push-detail",
                        meta: createAuthRouteMeta({
                            permissions: [PERMISSIONS.VIEW_ASSET_DETAIL],
                            isSubShow: false,
                            subGroup: "app-push",
                        }),
                        props: true,
                        beforeEnter: async (to) => {
                            const [path, response] = await useRouterProtect({
                                to,
                                PERMISSIONS: PERMISSIONS.VIEW_ASSET_DETAIL,
                                api: assetApi.getAppPush,
                            })

                            if (path === true) {
                                to.params.initialAppPushResponse = response
                            }
                            return path
                        },
                    },
                    {
                        path: "app-push/add", // 素材新增 APP推播
                        component: () =>
                            import(
                                "@/pages/MarketingResourcesGroup/MarketingResourcesAppPushAddPage.vue"
                            ),
                        name: "add-app-push",
                        meta: createAuthRouteMeta({
                            permissions: [PERMISSIONS.ADD_ASSET],
                            isSubShow: false,
                            subGroup: "app-push",
                        }),
                    },
                    {
                        path: "app-push/:id/edit", // 素材編輯 APP推播
                        component: () =>
                            import(
                                "@/pages/MarketingResourcesGroup/MarketingResourcesAppPushEditPage.vue"
                            ),
                        name: "edit-app-push",
                        meta: createAuthRouteMeta({
                            permissions: [PERMISSIONS.EDIT_ASSET],
                            isSubShow: false,
                            subGroup: "app-push",
                        }),
                        props: true,
                        beforeEnter: async (to) => {
                            const [path, response] = await useRouterProtect({
                                to,
                                PERMISSIONS: PERMISSIONS.EDIT_ASSET,
                                api: assetApi.getAppPush,
                            })

                            if (path === true) {
                                to.params.initialAppPushResponse = response
                            }
                            return path
                        },
                    },
                    {
                        path: "app-push/:id/review", // 素材審核 APP推播
                        component: () =>
                            import(
                                "@/pages/MarketingResourcesGroup/MarketingResourcesAppPushReviewPage.vue"
                            ),
                        name: "review-app-push",
                        meta: createAuthRouteMeta({
                            permissions: [PERMISSIONS.REVIEW_ASSET],
                            isSubShow: false,
                            subGroup: "app-push",
                        }),
                        props: true,
                        beforeEnter: async (to) => {
                            const [path, response] = await useRouterProtect({
                                to,
                                PERMISSIONS: PERMISSIONS.REVIEW_ASSET,
                                api: assetApi.getAppPush,
                            })

                            if (path === true) {
                                to.params.initialAppPushResponse = response
                            }
                            return path
                        },
                    },
                ],
            },
        ],
    },
]
